//
// LocationOperations.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../layoutOverlayMap/location/LocationFeature";
import "../../state/RendererState";
import "@sas-dvr/ltjs-commons/models/warnings/Warning";
import "../../layoutOverlayMap/location/Pin";
import "../../layoutOverlayMap/location/Buffer";
import "../../layoutOverlayMap/location/Route";
import "@sas-dvr/ltjs-commons/maps/MapSearchResult";
import "@sas-dvr/ltjs-commons/maps/MapSearchHint";

var LocationOperations = createModule("gtl::LocationOperations", [], EventDispatcher, [
    {
        REVERSE_GEOCODE_COMPLETE: 30054,
        ROUTE_COMPLETE: 30056,
        SELECTION_CHANGED: 30053,
        FEATURES_UPDATED: 30051,
        SEARCH_HINTS_READY: 30050,
        GEO_ENRICHMENT_COMPLETE: 30057,
        SEARCH_COMPLETE: 30049,
        FEATURE_SELECTED: 30052,
        LOCATION_UPDATED: 30058,
        BUFFER_COMPLETE: 30055,
        FEATURES_MOVED: 30059,
    },
    ,
    ,
    ,
    {
        deleteSearchResults: [0,[3]],
        setAllFeaturesVisible: [0,2],
        getWarnings: [[1]],
        requestSearchHints: [0,7,4,2],
        getFeatureStates: [1],
        getSearchTerm: [7],
        listenForLocation: [0,2],
        addGeographicSelection: [0,1],
        setFeatureStates: [0,1],
        search: [0,7,7,11,4],
        createPin: [1,11,2],
        cancelReverseGeocode: [0],
        getLastLocation: [11],
        getSearchPins: [[1]],
        addPinCopy: [1,1],
        clearFeature: [0,1],
        clearAllFeatures: [0],
        createWaypoint: [1,11,2],
        reverseGeocode: [0,11,2],
        getSearchHints: [[1]],
        canDoGeographicSelections: [2],
        getReverseGeocodeResult: [1],
        canDoSearch: [2],
        getMaximumBufferDistance: [5,4,4],
        clearSearch: [0],
        getFeatures: [[1]],
        setToken: [0,7],
        cancelSearch: [0],
        selectFeatures: [0,[3]],
        createRoute: [1,[1],1],
        getToken: [7],
        addFeatureToMap: [0,1],
        getSearchResults: [[1]],
        addCurrentLocation: [1],
        createPointBuffer: [1,11,2,1],
    },
    ,
    ,
]);
export default LocationOperations;
